<template>
  <BasePanel :headline="$t('lang_CONTRACTS_LABEL_PANEL_CAPTION_ADVANCE') + ' (' + $t('lang_GENERIC_CAPTION_BETA_DO_NOT_USE') + ')'" :alvqa="alvqa">
    <template v-slot:panelContent>
      <v-container fluid class="pl-0">
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="listItems"
              hide-default-footer
              :items-per-page="300"
              :header-props="{ sortIcon: '' }"
              :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
              class="noMinWidth"
            >
              <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
              </template>

              <template v-slot:[`item.description`]="{ item }">
                <div :alvqa="alvqa + '-list-row-text-description'">
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:[`item.enteredBy`]="{ item }">
                <BaseTooltip>
                  <template v-slot:content>
                    <div
                      class="ellipsis"
                      :alvqa="alvqa + '-list-row-text-entered-by'"
                    >
                      {{ enteredByText(item) }}
                    </div>
                  </template>
                  <template v-slot:text>{{ enteredByText(item) }}</template>
                </BaseTooltip>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div
                  class="text-right"
                  :alvqa="alvqa + '-list-row-text-amount'"
                >
                  {{ $alvPlugin.formatMoney(item.amount) }}
                </div>
              </template>
              <template v-slot:[`item.balance`]="{ item }">
                <div
                  class="text-right"
                  :alvqa="alvqa + '-list-row-text-balance'"
                >
                  {{ $alvPlugin.formatMoney(item.balance) }}
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel";
import BaseTooltip from "@/components/_base/BaseTooltip";

export default {
  name: "PublishingContractsAdvanceReadOnlyPanel",
  components: {
    BasePanel,
    BaseTooltip,
  },
  props: {
    itemId: {
      type: Number,
    },
  },
  data() {
    return {
      alvqa:
        "publishing-contracts-advance-list-row-" +
        this.itemId +
        "-read-only",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("lang_GENERIC_CAPTION_DESCRIPTION"),
          align: "left",
          value: "description",
          class: "text-no-wrap",
          sortable: false,
          alvqa: this.alvqa + "-header-description",
        },
        {
          text: this.$t("lang_LABEL_CONTRACTS_ADVANCE_ENETERED"),
          align: "left",
          value: "enteredBy",
          class: "text-no-wrap",
          sortable: false,
          width: "160px",
          alvqa: this.alvqa + "-header-entered-by",
        },
        {
          text: this.$t("lang_GENERIC_CAPTION_AMOUNT") + " " + this.$store.getters.getSelectedCurrency,
          align: "right",
          value: "amount",
          class: "text-no-wrap",
          sortable: false,
          width: "130px",
          alvqa: this.alvqa + "-header-amount",
        },
        {
          text: this.$t("lang_GENERIC_CAPTION_BALANCE") + " " + this.$store.getters.getSelectedCurrency,
          align: "right",
          value: "balance",
          class: "text-no-wrap",
          sortable: false,
          width: "130px",
          alvqa: this.alvqa + "-header-balance",
        },
      ];
    },
    listItems() {
      return this.$store.getters.getPublishingContractsAdvance;
    },
  },
  methods: {
    getEnteredTranslation(enteredValue) {
      if (enteredValue === "manual") return this.$t("lang_GENERIC_CAPTION_MANUAL");
      if (enteredValue === "automatic") return this.$t("lang_GENERIC_CAPTION_AUTOMATIC");
    },
    enteredByText(item) {
      const date = item.enteredOn !== null ? this.$d(new Date(item.enteredOn), "alvDateTime") : "";
      const mode = this.getEnteredTranslation(item.entered);
      return `${mode}, ${item.enteredBy} ${this.$t("lang_GENERIC_CAPTION_ON")} ${date}`;
    },
  },
};
</script>
